﻿import React from 'react';
import { CardItemValue } from "../CardItemValue";
import { styled } from "@mui/material/styles";

const Root = styled(CardItemValue)(({ theme }) => ({
  color: theme.palette.success.main,
}));

type CardItemValueSuccessProps = React.ComponentPropsWithoutRef<'span'>;

const CardItemValueSuccess = (props: CardItemValueSuccessProps) => {
  return <Root {...props} />
}

export { CardItemValueSuccess }
